import {Map} from "immutable"
import undoable  from 'redux-undo'

const presetSettings = (settings = Map({}), action) => {
    switch(action.type){
        case 'CHANGE_PRESET_COLOR':
            return settings.setIn([action.preset,"color"], action.setting)
        case 'LOAD_PRESET_SETTINGS':
            console.log("loading preset settings", action.settings)
            return action.settings
        case 'SET_PRESET_NAME':
            
            return settings.setIn([action.preset, "name"], action.presetName.substring(0, 5).toUpperCase()) 
        default:
            return settings

    }
}

const undoablePresetSettings = undoable(presetSettings)


export default undoablePresetSettings